import React, { createContext, useContext, useState } from "react";

import { SurveyContext } from "./survey";
import { SurveyQuestionsVisibilityContext } from "./survey-questions-visibility";

import * as Navigation from "../utils/survey/navigation";

export const SurveyNavigationContext = createContext();

const SurveyNavigationProvider = ({ children }) => {
  const { questionnaire, pages, answers } = useContext(SurveyContext);
  const { questionsVisibility } = useContext(SurveyQuestionsVisibilityContext);

  const [currentPage, setCurrentPage] = useState(
    Navigation.loadInitialPage(questionnaire, pages, answers, questionsVisibility)
  );
  const visibleDimensions = pages[currentPage];

  const navigateToPreviousPage = () => setCurrentPage((currentPage) => currentPage - 1);
  const navigateToNextPage = () => setCurrentPage((currentPage) => currentPage + 1);

  return (
    <SurveyNavigationContext.Provider
      value={{ currentPage, visibleDimensions, navigateToPreviousPage, navigateToNextPage }}
    >
      {children}
    </SurveyNavigationContext.Provider>
  );
};

export default SurveyNavigationProvider;
